import configureEnvironment from '@sbvr/common/legacy-shared/setup/configureEnvironment';
configureEnvironment();
